import { Navigate, Outlet } from "react-router-dom";
import { useAppStore } from "@/store/appStore";

export function ProtectedRoute() {
  const authReady = useAppStore((s) => s.authReady);
  const isAuthenticated = useAppStore((s) => s.isAuthenticated);
  if (!authReady) {
    return (
      <div className="auth-layout" style={{ alignItems: "center", justifyContent: "center" }}>
        <p style={{ color: "var(--text-muted)" }}>Checking session…</p>
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export function GuestRoute() {
  const authReady = useAppStore((s) => s.authReady);
  const isAuthenticated = useAppStore((s) => s.isAuthenticated);
  if (!authReady) {
    return (
      <div className="auth-layout" style={{ alignItems: "center", justifyContent: "center" }}>
        <p style={{ color: "var(--text-muted)" }}>Checking session…</p>
      </div>
    );
  }
  if (isAuthenticated) return <Navigate to="/" replace />;
  return <Outlet />;
}
